import { useMutation } from "@apollo/client";

import { GqlSettingsResearchTypeSpeciesDeleteInput } from "~/__generated__";

import { SettingsResearchTypeEditRoute_RemoveSpeciesDocument } from "../mutations.generated";
import {
    SettingsResearchTypeEditRoute_GetByIdDocument,
    SettingsResearchTypeEditRoute_SpeciesGetAllAssignableDocument,
} from "../queries.generated";

export default function useSettingsResearchTypeEditRoute_RemoveSpecies() {
    const [mutate, { loading, error }] = useMutation(SettingsResearchTypeEditRoute_RemoveSpeciesDocument, {
        refetchQueries: [
            SettingsResearchTypeEditRoute_GetByIdDocument,
            SettingsResearchTypeEditRoute_SpeciesGetAllAssignableDocument,
        ],
    });

    const removeResearchTypeSpecies = async (input: GqlSettingsResearchTypeSpeciesDeleteInput): Promise<void> => {
        await mutate({ variables: { input } });
    };

    return {
        loading,
        error,
        removeResearchTypeSpecies,
    };
}
